

exports.__esModule = true;
exports.$PayWithSelectionRoute = undefined;

require('./directive');

var _squid = require('squid');

var $PayWithSelectionRoute = exports.$PayWithSelectionRoute = _squid.$ComponentRoute.extend('$PayWithSelectionRoute', {

    path: 'payWithSelection',

    directive: 'xo-pay-with-selection-page',

    params: {
        targetPage: null,
        source: null,
        showNotYou: null
    },

    auth: false,

    titleContent: 'base.logIn',

    venmoHeaders: {
        venmoTabs: true
    },

    trackingData: {
        fptiState: 'payWithSelection',
        suppressTransitionLog: true, // We will be suppressing the Server Side Tracking for this page
        templateName: 'login.dust',
        pageGoal: 'Select a payment scheme',
        buzname: {
            'fullpage': {
                'pagename': '%::fullpage-login',
                'pagename2': '%::fullpage-login:member:hermes:',
                'version': 'member:%:'
            },
            'ulLogin': {
                'pagename': '%::fullpage-ullogin',
                'pagename2': '%::fullpage-ullogin:member:hermes:',
                'version': 'member:%:'
            }
            // More page qualifiers come here...
        }
    },

    children: []
});

angular.value("$PayWithSelectionRoute", $PayWithSelectionRoute);
_squid.$ComponentRoute;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-pay-with-selection/route.js
// module id = ./pages/xo-pay-with-selection/route.js
// module chunks = 1